import { render, staticRenderFns } from "./AddItem.vue?vue&type=template&id=1a39b08b&scoped=true&"
import script from "./AddItem.vue?vue&type=script&lang=ts&"
export * from "./AddItem.vue?vue&type=script&lang=ts&"
import style0 from "./AddItem.vue?vue&type=style&index=0&id=1a39b08b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a39b08b",
  null
  
)

export default component.exports